import { sv } from '@ucheba/utils/helpers/styles/variables'

import styled from 'styled-components'
import AvatarMask from '@ucheba/ui/icons/icon__avatar-mask.svg'

import { Avatar } from '@ucheba/ui/components/Avatar/touch'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;

  border-radius: 8px;
  background-color: ${sv.color.silver};
`

export const AvatarStyled = styled(Avatar)`
  position: absolute;
  top: 0;
  left: 0;

  border-radius: 0;
`

export const AvatarMaskStyled = styled(AvatarMask)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  z-index: 5;
`

export const AvatarWrapper = styled.div`
  position: relative;
  width: 96px;
  height: 96px;

  overflow: hidden;
  background: ${sv.color.gray5};
`
